export const softwareLicenseDirectDepositModal = (
    state = { },
    action
) => {
    switch (action.type) {
        default:
            return state;
    }
};
